// extracted by mini-css-extract-plugin
module.exports = {"chooseTemplateButton":"CreateCustomWaiver_chooseTemplateButton__1IiAj"};